import axios from 'axios';
import { OriginalDecisionInSnippet } from '../../../../../decision/decision.types';

export function fetchLawCardReferenceDecisions(
  articleId: string,
): Promise<{
  data: { refdecisions: Array<OriginalDecisionInSnippet> };
}> {
  return axios.get('/getLawCardReferenceDecisions', {
    params: {
      articleId,
    },
  });
}
